<div class="re-mb-30">
  <div class="re-summary-row">
    <div>{{ 'general.tariff.contractBegin' | translate }}</div>
    <div>{{ newHomeData?.startDate | date }}</div>
  </div>
  <div class="re-summary-row">
    <div>{{ 'address.postCode.postCodeAndCity' | translate }}</div>
    <div>{{ personalData?.addressData?.postCode }}, {{ personalData?.addressData?.city }}</div>
  </div>
  <div class="re-summary-row">
    <div>{{ 'address.street.title' | translate }}</div>
    <div>{{ personalData?.addressData.street }}</div>
  </div>
  <div class="re-summary-row">
    <div>{{ 'address.housenumber.title' | translate }}</div>
    <div>{{ personalData?.addressData.housenumber }}</div>
  </div>
  @if (!hasEmail) {
    <div class="re-summary-row">
      <div>{{ 'address.email.title' | translate }}</div>
      <div>{{ personalData?.email }}</div>
    </div>
  }
  @if (personalData?.phonenumber) {
    <div class="re-summary-row">
      <div>{{ 'address.phonenumber.title' | translate }}</div>
      <div>{{ personalData?.phonenumber }}</div>
    </div>
  }
</div>

@for (meter of newHomeData?.meterData; track meter) {
  <div>
    <h5 class="re-mb-30 re-mt-45">
      {{ 'general.tariff.meterWithDivision' | translate: { division: meter.divisionId | verbrauchstyp } }}
    </h5>
    <div class="re-summary-row">
      <div>{{ 'general.customerData.meternumber' | translate }}</div>
      <div>{{ meter?.meterNumber}}</div>
    </div>
    @if (meter.register?.length) {
      @for (register of meter?.register; track register) {
        <div class="re-summary-row">
          <div>{{ 'meterreadings.meterreading' | translate }} {{ ['HT', 'NT'].includes(register.typ) ? ('' | zaehlwerktyp: register.typ) : '' }}</div>
          <div>{{ register?.wert ? register.wert + ' ' + [register.einheit | unitPretty] :
          (meter.isSmartMeter ? 'meterreadings.smartmeter.readingInfoShort' : 'meterreadings.info.enterLaterShort') | translate }}</div>
        </div>
      }
    }
  </div>
}
